export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_266.6420bc2f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};